
import AuraEater from './components/DreamWeave/games/aura-eater/AuraEater';
import SynapticStacking from './components/DreamWeave/SynapticStacking';
import SynapticSerpent from './components/DreamWeave/games/synaptic-serpent';
import CosmicAscent from './components/DreamWeave/CosmicAscent';
import StarlightSentinel from './components/DreamWeave/games/starlight-sentinel/StarlightSentinel';

export const gameComponents = {
    auraEater: AuraEater,
    synapticStacking: SynapticStacking,
    synapticSerpent: SynapticSerpent,
    cosmicAscent: CosmicAscent,
    starlightSentinel: StarlightSentinel,
};
